import { Button, Flex, FormLabel, InputGroup, Select, useColorModeValue, Text, ScaleFade, Box } from '@chakra-ui/react'
import Card from 'components/card/Card'
import { ChangeEvent, useEffect, useRef, useState } from 'react'
import LogicChart from './LogicChart';
import { useData } from 'services/data/DataProvider';
import { Trade, UserTradeLogic } from 'views/trader/trades/variables/types';
import ShowTradesModal from 'views/trader/components/ShowTradesModal';

const TradeLogicCategories = (props: { usedlogic: UserTradeLogic }) => {

    const { usertrades, defaultcurrency } = useData();
    const tradesModalRef = useRef(null);

    const bgcolor = useColorModeValue('white', 'navy.900');
    const textColor = useColorModeValue('secondaryGray.900', 'white');
    const textColorSecondary = useColorModeValue('secondaryGray.700', 'secondaryGray.500');

    interface smdata { id: number, name: string, trades: Trade[], nett: number }

    const [logicData, setLogicData] = useState<smdata[]>([]);
    const [loading, setLoading] = useState(false);
    const [category, setCategory] = useState('');
    const [nocatsdata, setnocatsdata] = useState(false);

    useEffect(() => {
        setnocatsdata(nodata())
    }, [props.usedlogic])

    const nodata = () => {
        return props.usedlogic.market_condition.length < 1 &&
            props.usedlogic.key_level.length < 1 &&
            props.usedlogic.htf.length < 1 &&
            props.usedlogic.htf_trend.length < 1 &&
            props.usedlogic.etf.length < 1 &&
            props.usedlogic.entry.length < 1 &&
            props.usedlogic.stop.length < 1 &&
            props.usedlogic.target.length < 1;
    }

    useEffect(() => {
        updateCategory(category);
    }, [usertrades])

    const selectCategory = (e: ChangeEvent<HTMLSelectElement>) => {
        updateCategory(e.target.value);
    }

    const updateCategory = (cat: string) => {
        setLoading(true)
        setCategory(cat);

        logicData.length = 0;

        let smarr: smdata[] = [];

        switch (cat) {
            case 'market_condition':
                props.usedlogic.market_condition.forEach((value, index) => {
                    let smd: smdata = { id: index, name: value, trades: [], nett: 0 }
                    smarr.push(smd)
                })
                break;
            case 'key_level':
                props.usedlogic.key_level.forEach((value, index) => {
                    let smd: smdata = { id: index, name: value, trades: [], nett: 0 }
                    smarr.push(smd)
                })
                break;
            case 'htf':
                props.usedlogic.htf.forEach((value, index) => {
                    let smd: smdata = { id: index, name: value, trades: [], nett: 0 }
                    smarr.push(smd)
                })
                break;
            case 'htf_trend':
                props.usedlogic.htf_trend.forEach((value, index) => {
                    let smd: smdata = { id: index, name: value, trades: [], nett: 0 }
                    smarr.push(smd)
                })
                break;
            case 'etf':
                props.usedlogic.etf.forEach((value, index) => {
                    let smd: smdata = { id: index, name: value, trades: [], nett: 0 }
                    smarr.push(smd)
                })
                break;
            case 'entry':
                props.usedlogic.entry.forEach((value, index) => {
                    let smd: smdata = { id: index, name: value, trades: [], nett: 0 }
                    smarr.push(smd)
                })
                break;
            case 'stop':
                props.usedlogic.stop.forEach((value, index) => {
                    let smd: smdata = { id: index, name: value, trades: [], nett: 0 }
                    smarr.push(smd)
                })
                break;
            case 'target':
                props.usedlogic.target.forEach((value, index) => {
                    let smd: smdata = { id: index, name: value, trades: [], nett: 0 }
                    smarr.push(smd)
                })
                break;
        }

        updateCategoryData(usertrades, smarr, cat);

    }



    const updateCategoryData = (trades: Trade[], smarr: smdata[], category: string) => {

        //alert(JSON.stringify(smarr))

        let index;

        for (let tr of trades) {
            if (tr.trade_logic && tr.trade_logic.length > 0) {

                let ex = (tr.currency !== defaultcurrency ? tr.exchange : 1);

                switch (category) {
                    case 'market_condition':
                        index = smarr.findIndex((logic) => logic.name === tr.trade_logic[0].market_condition);
                        if (index > -1) {
                            smarr[index].trades.push(tr);
                            smarr[index].nett += (tr.nett / ex);
                        }
                        break;
                    case 'key_level':
                        index = smarr.findIndex((logic) => logic.name === tr.trade_logic[0].key_level);
                        if (index > - 1) {
                            smarr[index].trades.push(tr);
                            smarr[index].nett += (tr.nett / ex);
                        }
                        break;
                    case 'htf':
                        index = smarr.findIndex((logic) => logic.name === tr.trade_logic[0].htf);
                        if (index > -1) {
                            smarr[index].trades.push(tr);
                            smarr[index].nett += (tr.nett / ex);
                        }
                        break;
                    case 'htf_trend':
                        index = smarr.findIndex((logic) => logic.name === tr.trade_logic[0].htf_trend);
                        if (index > -1) {
                            smarr[index].trades.push(tr);
                            smarr[index].nett += (tr.nett / ex);
                        }
                        break;
                    case 'etf':
                        index = smarr.findIndex((logic) => logic.name === tr.trade_logic[0].etf);
                        if (index > -1) {
                            smarr[index].trades.push(tr);
                            smarr[index].nett += (tr.nett / ex);
                        }
                        break;
                    case 'entry':
                        index = smarr.findIndex((logic) => logic.name === tr.trade_logic[0].entry);
                        if (index > -1) {
                            smarr[index].trades.push(tr);
                            smarr[index].nett += (tr.nett / ex);
                        }
                        break;
                    case 'stop':
                        index = smarr.findIndex((logic) => logic.name === tr.trade_logic[0].stop);
                        if (index > -1) {
                            smarr[index].trades.push(tr);
                            smarr[index].nett += (tr.nett / ex);
                        }
                        break;
                    case 'target':
                        index = smarr.findIndex((logic) => logic.name === tr.trade_logic[0].target);
                        if (index > -1) {
                            smarr[index].trades.push(tr);
                            smarr[index].nett += (tr.nett / ex);
                        }
                        break;
                }
            }
        }
        setLogicData(smarr);
        setLoading(false);
    }

    const showtrades = (index: any) => {
        tradesModalRef.current.openModal(logicData[index].trades, logicData[index].name, '');
    }

    return (
        <Card w='100%' h='100%' borderWidth={'1px'} bg='transparent'>
            <Flex>
                <FormLabel fontWeight='bold' fontSize='md' mb='8px' color={textColor} mt='-32px' bg={bgcolor} px='10px'>Logic variables</FormLabel>
            </Flex>
            <Flex>
                {nocatsdata ? (

                    <Flex mt='30px' justify={'center'} w='100%'>
                        <ScaleFade initialScale={0.5} in={true} transition={{ exit: { delay: 0.5 }, enter: { duration: 1 } }}>
                            <Box p='10px' color={textColorSecondary} >
                                <Text color={textColorSecondary} fontSize='md' mt='20px' mb='20px' ms='20px'>No logic variables data</Text>
                            </Box>
                        </ScaleFade>
                    </Flex>
                ) : (
                    <InputGroup size='md' mt='20px'>
                        <Button fontWeight={'700'} px={10} borderRightRadius={'0px'} isLoading={loading}>
                            Variable
                        </Button>
                        <Select borderLeftRadius={'0px'} isDisabled={loading} onChange={selectCategory}>
                            <option value=''>Select ...</option>
                            <option hidden={props.usedlogic.market_condition.length < 1} value='market_condition' >Market conditions</option>
                            <option hidden={props.usedlogic.key_level.length < 1} value='key_level'>Recent key levels</option>
                            <option hidden={props.usedlogic.htf.length < 1} value='htf'> Higher timeframe</option>
                            <option hidden={props.usedlogic.htf_trend.length < 1} value='htf_trend'>HTF trend</option>
                            <option hidden={props.usedlogic.etf.length < 1} value='etf'> Entry timeframe</option>
                            <option hidden={props.usedlogic.entry.length < 1} value='entry'> Entry signal/level</option>
                            <option hidden={props.usedlogic.stop.length < 1} value='stop'> Initial stop logic</option>
                            <option hidden={props.usedlogic.target.length < 1} value='target'> Target logic</option>
                        </Select>
                    </InputGroup>
                )}
            </Flex >
            <Flex h='100%'>
                {!nocatsdata && <LogicChart strats={logicData} currency={defaultcurrency} showtrades={showtrades} />}
            </Flex>
            <ShowTradesModal ref={tradesModalRef} />
        </Card >
    )
}

export default TradeLogicCategories